module.exports = __webpack_public_path__ + "assets/images/mci-logo-login-page.png";